module.exports = __webpack_public_path__ + "static/img/MARCUS_STOINIS.250876d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MARCUS_STOINIS.jpg
// module id = 0aFU
// module chunks = 0